import moment from "moment";
export const tnmformatnumber = tnm => {
  // console.log(tnm.createdate);
  return (
    "22" +
    "-" +
    pad(tnm.custnumber, 3) +
    "-" +
    "T" +
    pad(tnm.tmnumber, 2)
  );
};
export const invformatnumber = inv => {
  // console.log(inv.createdate);
  return (
    "22" +
    "-" +
    pad(inv.custnumber, 3) +
    "-" +
    "I" +
    pad(inv.number, 2)
  );
};
export const estformatnumber = est => {
  // console.log(est.createdate);
  return (
    "22" +
    "-" +
    pad(est.custnumber, 3) +
    "-" +
    "E" +
    pad(est.estimateNumber, 2)
  );
};
function pad(n, width, z) {
  z = z || "0";
  n = n + "";
  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}



// WEBPACK FOOTER //
// ./src/services/tnminvnumbers.js